module.exports = __webpack_public_path__ + "img/icon-side-bar-8.07c07485.svg";